import filters from 'config/algolia/filters';
import sorts from 'config/algolia/sorts';
import FilterContainer from '@fogia/core-web/containers/FilterContainer';
import useAppSelector from '@fogia/core-web/hooks/useAppSelector';
import useSaveResponse from '@fogia/core-web/hooks/useSaveResponse';
import React, { useEffect, useRef, useState } from 'react';
import { shallowEqual } from 'react-redux';
import Pagination from 'components/Pagination';
import CategoryModule from 'components/Category/Category';
import styled from 'libs/styled';
import { inServer } from '@fogia/core-web/constants';
import Breadcrumbs from 'components/Breadcrumbs';

const Wrapper = styled('div')``;

const Category = () => {
    const wrapperRef = useRef({});
    const pageContent = useAppSelector(({ page }) => page?.data?.pageContent, shallowEqual);
    const categoryName = useAppSelector(({ page }) => page?.data?.settings?.category?.name);

    const mergedFilters = { ...filters };
    const defaultFilters = categoryName ? [[`categories:"${categoryName}"`], [`isVariant:false`]] : [];

    // Save response from container
    const [savedResponse, saveResponse] = useSaveResponse();
    const pageSearch = useAppSelector(({ page }) => page.search);
    const [currentPage, setCurrentPage] = useState(() => {
        const search = inServer ? pageSearch : window.location.search;
        const pageParam = new URLSearchParams(search || '').get('page');
        const parsed = parseInt(pageParam, 10);
        return parsed > 1 ? parsed - 1 : 0;
    });
    const [pageCount, setPageCount] = useState(0);
    const [hitsCount, setHitsCount] = useState(null);
    const [currentSort, setCurrentSort] = useState(null);
    const prevSort = useRef(null);

    const productsPerPage = 20;

    const scrollToTop = (next, smooth = false) => {
        // Scroll back to top of wrapper on pagination
        const headerHeight =
            (!inServer && getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;

        setCurrentPage(next);
        if (wrapperRef && wrapperRef.current) {
            scrollTo({
                smooth,
                top: wrapperRef.current.offsetTop - headerHeight,
            });
        }
    };

    useEffect(() => {
        if (prevSort.current !== null && currentSort !== null && prevSort.current !== currentSort) {
            const url = new URL(window.location.href);
            url.searchParams.delete('page');
            window.history.replaceState({}, '', url.toString());
            scrollToTop(0);
        }
        prevSort.current = currentSort;
    }, [currentSort]);

    return (
        <>
            <Breadcrumbs />
            <Wrapper ref={wrapperRef}>
                <FilterContainer
                    config={mergedFilters}
                    filters={defaultFilters}
                    pageSize={productsPerPage}
                    pagination={currentPage}
                    sorts={sorts}
                    render={(props) => {
                        const { response } = props;
                        saveResponse(response);
                        if (response) setPageCount(response.pageCount);
                        if (response) setCurrentPage(response.page);
                        if (response) setHitsCount(response.hitsCount);

                        if (response?.sorts && currentSort !== response.sorts.find((sort) => sort.selected)?.index) {
                            setCurrentSort(response.sorts.find((sort) => sort.selected)?.index);
                        }

                        return (
                            savedResponse.current.products && (
                                <CategoryModule
                                    config={mergedFilters}
                                    response={savedResponse.current}
                                    hasCategoryFilter={!!categoryName}
                                    pageContent={
                                        !savedResponse.current.page && !savedResponse.current.selectedFilters?.length
                                            ? pageContent
                                            : undefined
                                    }
                                />
                            )
                        );
                    }}
                />
                {pageCount !== 0 && (
                    <Pagination
                        handleClick={scrollToTop}
                        page={currentPage}
                        pageCount={pageCount}
                        pageSize={productsPerPage}
                        hitsCount={hitsCount}
                    />
                )}
            </Wrapper>
        </>
    );
};
export default Category;
